import React, { useState, useEffect, useRef } from 'react';
import { Button, Typography, Radio, Progress } from 'antd';
import { TrophyOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const LivestockQuiz = ({ onGameComplete }) => {
    const questions = [
        {
            question: "گائے کی دودھ دینے کی مدت کتنی ہوتی ہے؟",
            options: ["6-8 ماہ", "10-12 ماہ", "14-16 ماہ", "18-20 ماہ"],
            correct: 1
        },
        {
            question: "بھیڑ کی اوسط عمر کتنی ہوتی ہے؟",
            options: ["5-7 سال", "8-10 سال", "10-12 سال", "12-15 سال"],
            correct: 2
        },
        {
            question: "مرغی ایک دن میں کتنے انڈے دیتی ہے؟",
            options: ["1 انڈا", "2-3 انڈے", "4-5 انڈے", "6-7 انڈے"],
            correct: 0
        },
        {
            question: "بکری کا حمل کتنا عرصہ رہتا ہے؟",
            options: ["3 ماہ", "5 ماہ", "7 ماہ", "9 ماہ"],
            correct: 1
        },
        {
            question: "گھوڑے کی عمر کا حساب کیسے لگایا جاتا ہے؟",
            options: ["دانت دیکھ کر", "قد دیکھ کر", "وزن دیکھ کر", "رنگ دیکھ کر"],
            correct: 0
        },
        {
            question: "بھینس کا دودھ کس موسم میں زیادہ ہوتا ہے؟",
            options: ["گرمی", "سردی", "بہار", "موسم برسات"],
            correct: 2
        },
        {
            question: "مرغی کے انڈے کو سینے میں کتنا وقت لگتا ہے؟",
            options: ["18 دن", "21 دن", "25 دن", "28 دن"],
            correct: 1
        },
        {
            question: "گائے کو کتنے دن بعد دوبارہ حاملہ کیا جا سکتا ہے؟",
            options: ["30-40 دن", "45-60 دن", "60-90 دن", "90-120 دن"],
            correct: 1
        },
        {
            question: "بکری کا دودھ کس بیماری کے لیے مفید ہے؟",
            options: ["ذیابیطس", "دل کی بیماری", "ہاضمے کی بیماری", "ساری بیماریاں"],
            correct: 2
        },
        {
            question: "بھیڑ کی اون کتنی بار کاٹی جاتی ہے؟",
            options: ["سال میں ایک بار", "سال میں دو بار", "سال میں تین بار", "سال میں چار بار"],
            correct: 0
        },
        {
            question: "مرغی کو کتنا پانی روزانہ چاہیے؟",
            options: ["100-150 ملی لیٹر", "200-250 ملی لیٹر", "300-400 ملی لیٹر", "500-600 ملی لیٹر"],
            correct: 1
        },
        {
            question: "گائے کا بچھڑا کتنے دن بعد ٹھوس خوراک کھانا شروع کرتا ہے؟",
            options: ["7-10 دن", "14-21 دن", "30-40 دن", "50-60 دن"],
            correct: 1
        },
        {
            question: "بھینس کا دودھ کس میں زیادہ چکنائی ہوتی ہے؟",
            options: ["گائے کے دودھ سے", "بکری کے دودھ سے", "بھیڑ کے دودھ سے", "سب سے زیادہ"],
            correct: 3
        },
        {
            question: "بکری کو کتنا چارہ روزانہ چاہیے؟",
            options: ["2-3 کلو", "4-5 کلو", "6-7 کلو", "8-10 کلو"],
            correct: 1
        },
        {
            question: "گھوڑے کو کتنا چارہ روزانہ چاہیے؟",
            options: ["5-7 کلو", "8-10 کلو", "12-15 کلو", "18-20 کلو"],
            correct: 2
        },
        {
            question: "مرغی کی کون سی نسل زیادہ انڈے دیتی ہے؟",
            options: ["لیگھارن", "رہوڈ آئی لینڈ ریڈ", "پلیموتھ راک", "براہما"],
            correct: 0
        },
        {
            question: "بھیڑ کو کس موسم میں زیادہ دیکھ بھال چاہیے؟",
            options: ["گرمی", "سردی", "بہار", "موسم برسات"],
            correct: 3
        },
        {
            question: "گائے کا دودھ کتنے درجہ حرارت پر محفوظ رکھا جا سکتا ہے؟",
            options: ["2-4 ڈگری", "4-6 ڈگری", "6-8 ڈگری", "8-10 ڈگری"],
            correct: 0
        },
        {
            question: "بکری کو کتنا نمک روزانہ چاہیے؟",
            options: ["5-10 گرام", "10-15 گرام", "15-20 گرام", "20-25 گرام"],
            correct: 1
        },
        {
            question: "گھوڑے کو کتنا پانی روزانہ چاہیے؟",
            options: ["20-30 لیٹر", "30-40 لیٹر", "40-50 لیٹر", "50-60 لیٹر"],
            correct: 2
        },
        {
            question: "بھینس کا بچھڑا کتنے دن بعد دودھ چھوڑتا ہے؟",
            options: ["3-4 ماہ", "5-6 ماہ", "7-8 ماہ", "9-10 ماہ"],
            correct: 1
        },
        {
            question: "مرغی کو کتنا چارہ روزانہ چاہیے؟",
            options: ["50-70 گرام", "100-120 گرام", "150-200 گرام", "250-300 گرام"],
            correct: 1
        },
        {
            question: "گائے کو کتنا چارہ روزانہ چاہیے؟",
            options: ["10-15 کلو", "20-25 کلو", "30-35 کلو", "40-45 کلو"],
            correct: 1
        },
        {
            question: "بکری کا دودھ کس میں زیادہ پروٹین ہوتا ہے؟",
            options: ["گائے کے دودھ سے", "بھینس کے دودھ سے", "بھیڑ کے دودھ سے", "سب سے زیادہ"],
            correct: 0
        },
        {
            question: "بھیڑ کو کتنا چارہ روزانہ چاہیے؟",
            options: ["1-2 کلو", "2-3 کلو", "3-4 کلو", "4-5 کلو"],
            correct: 1
        },
        {
            question: "گھوڑے کو کتنا نمک روزانہ چاہیے؟",
            options: ["20-30 گرام", "30-40 گرام", "40-50 گرام", "50-60 گرام"],
            correct: 1
        },
        {
            question: "مرغی کے انڈے کو کتنے درجہ حرارت پر رکھنا چاہیے؟",
            options: ["10-15 ڈگری", "15-20 ڈگری", "20-25 ڈگری", "25-30 ڈگری"],
            correct: 1
        },
        {
            question: "گائے کو کتنا پانی روزانہ چاہیے؟",
            options: ["30-40 لیٹر", "50-60 لیٹر", "70-80 لیٹر", "90-100 لیٹر"],
            correct: 2
        },
        {
            question: "بھینس کو کتنا چارہ روزانہ چاہیے؟",
            options: ["25-30 کلو", "35-40 کلو", "45-50 کلو", "55-60 کلو"],
            correct: 1
        },
        {
            question: "بکری کا دودھ کتنے درجہ حرارت پر محفوظ رکھا جا سکتا ہے؟",
            options: ["2-4 ڈگری", "4-6 ڈگری", "6-8 ڈگری", "8-10 ڈگری"],
            correct: 0
        },
        {
            question: "گائے کا دودھ کتنے دن تک فریزر میں رکھا جا سکتا ہے؟",
            options: ["1-2 ماہ", "3-4 ماہ", "5-6 ماہ", "7-8 ماہ"],
            correct: 2
        },
        {
            question: "بکری کا بچہ کتنے دن بعد چارہ کھانا شروع کرتا ہے؟",
            options: ["7-10 دن", "15-20 دن", "25-30 دن", "35-40 دن"],
            correct: 1
        },
        {
            question: "مرغی کی کون سی بیماری سب سے عام ہے؟",
            options: ["نیوکاسل", "برونکائٹس", "کوکسڈیوسس", "سب عام ہیں"],
            correct: 3
        },
        {
            question: "گھوڑے کو کتنی بار نہلانا چاہیے؟",
            options: ["روزانہ", "ہفتے میں دو بار", "ہفتے میں ایک بار", "مہینے میں ایک بار"],
            correct: 2
        },
        {
            question: "بھینس کو کتنا پانی روزانہ چاہیے؟",
            options: ["40-50 لیٹر", "60-70 لیٹر", "80-90 لیٹر", "100-120 لیٹر"],
            correct: 1
        },
        {
            question: "بھیڑ کو کتنا نمک روزانہ چاہیے؟",
            options: ["5-10 گرام", "10-15 گرام", "15-20 گرام", "20-25 گرام"],
            correct: 0
        },
        {
            question: "گائے کا دودھ کس میں زیادہ کیلشیم ہوتا ہے؟",
            options: ["بکری کے دودھ سے", "بھینس کے دودھ سے", "بھیڑ کے دودھ سے", "سب برابر"],
            correct: 1
        },
        {
            question: "مرغی کو کتنا وقت سورج کی روشنی چاہیے؟",
            options: ["8-10 گھنٹے", "12-14 گھنٹے", "16-18 گھنٹے", "20-22 گھنٹے"],
            correct: 1
        },
        {
            question: "بکری کا بچہ کتنے دن بعد دودھ چھوڑتا ہے؟",
            options: ["2-3 ماہ", "4-5 ماہ", "6-7 ماہ", "8-9 ماہ"],
            correct: 0
        },
        {
            question: "گھوڑے کو کتنی بار دانت چیک کروانے چاہیں؟",
            options: ["سال میں ایک بار", "سال میں دو بار", "سال میں تین بار", "سال میں چار بار"],
            correct: 0
        },
        {
            question: "بھینس کا دودھ کتنے دن تک ریفریجریٹر میں رکھا جا سکتا ہے؟",
            options: ["2-3 دن", "4-5 دن", "6-7 دن", "8-10 دن"],
            correct: 1
        },
        {
            question: "بھیڑ کو کتنا پانی روزانہ چاہیے؟",
            options: ["2-3 لیٹر", "4-5 لیٹر", "6-7 لیٹر", "8-10 لیٹر"],
            correct: 2
        },
        {
            question: "گائے کو کتنی بار ویکسینیشن کروانی چاہیے؟",
            options: ["سال میں ایک بار", "سال میں دو بار", "سال میں تین بار", "سال میں چار بار"],
            correct: 1
        },
        {
            question: "مرغی کے انڈے کو کتنے درجہ حرارت پر سینا چاہیے؟",
            options: ["35-37 ڈگری", "37-39 ڈگری", "39-41 ڈگری", "41-43 ڈگری"],
            correct: 1
        },
        {
            question: "بکری کو کتنا پانی روزانہ چاہیے؟",
            options: ["3-4 لیٹر", "5-6 لیٹر", "7-8 لیٹر", "9-10 لیٹر"],
            correct: 0
        },
        {
            question: "گھوڑے کو کتنی بار ورزش کروانی چاہیے؟",
            options: ["روزانہ", "ہفتے میں تین بار", "ہفتے میں دو بار", "ہفتے میں ایک بار"],
            correct: 1
        },
        {
            question: "بھینس کو کتنا نمک روزانہ چاہیے؟",
            options: ["15-20 گرام", "25-30 گرام", "35-40 گرام", "45-50 گرام"],
            correct: 2
        },
        {
            question: "گائے کا بچھڑا کتنے دن بعد ویکسینیشن کروانی چاہیے؟",
            options: ["7-10 دن", "15-20 دن", "30-35 دن", "45-50 دن"],
            correct: 2
        },
        {
            question: "مرغی کو کتنا کیلشیم روزانہ چاہیے؟",
            options: ["2-3 گرام", "4-5 گرام", "6-7 گرام", "8-9 گرام"],
            correct: 1
        },
        {
            question: "بھیڑ کو کتنی بار اون کاٹنی چاہیے؟",
            options: ["سال میں ایک بار", "سال میں دو بار", "سال میں تین بار", "سال میں چار بار"],
            correct: 0
        },
        {
            question: "بکری کو کتنی بار ویکسینیشن کروانی چاہیے؟",
            options: ["سال میں ایک بار", "سال میں دو بار", "سال میں تین بار", "سال میں چار بار"],
            correct: 1
        },
        {
            question: "گھوڑے کو کتنا کیلشیم روزانہ چاہیے؟",
            options: ["20-30 گرام", "40-50 گرام", "60-70 گرام", "80-90 گرام"],
            correct: 2
        },
        {
            question: "بھینس کو کتنی بار نہلانا چاہیے؟",
            options: ["روزانہ", "ہفتے میں دو بار", "ہفتے میں ایک بار", "مہینے میں ایک بار"],
            correct: 2
        },
        {
            question: "گائے کو کتنا کیلشیم روزانہ چاہیے؟",
            options: ["30-40 گرام", "50-60 گرام", "70-80 گرام", "90-100 گرام"],
            correct: 3
        },
        {
            question: "مرغی کو کتنا پروٹین روزانہ چاہیے؟",
            options: ["15-18 گرام", "20-25 گرام", "30-35 گرام", "40-45 گرام"],
            correct: 0
        },
        {
            question: "بھیڑ کو کتنی بار ویکسینیشن کروانی چاہیے؟",
            options: ["سال میں ایک بار", "سال میں دو بار", "سال میں تین بار", "سال میں چار بار"],
            correct: 1
        },
        {
            question: "بکری کو کتنا کیلشیم روزانہ چاہیے؟",
            options: ["5-8 گرام", "10-12 گرام", "15-18 گرام", "20-25 گرام"],
            correct: 2
        },
        {
            question: "گھوڑے کو کتنا پروٹین روزانہ چاہیے؟",
            options: ["500-600 گرام", "700-800 گرام", "900-1000 گرام", "1100-1200 گرام"],
            correct: 1
        },
        {
            question: "بھینس کو کتنا کیلشیم روزانہ چاہیے؟",
            options: ["40-50 گرام", "60-70 گرام", "80-90 گرام", "100-110 گرام"],
            correct: 3
        },
        {
            question: "گائے کو کتنا پروٹین روزانہ چاہیے؟",
            options: ["800-900 گرام", "1000-1100 گرام", "1200-1300 گرام", "1400-1500 گرام"],
            correct: 2
        },
        // Breed Identification Questions
        {
            question: "ساہیوال نسل کی گائے کا رنگ کیا ہوتا ہے؟",
            options: ["سرخ", "بھورا", "سیاہ", "چتکبرا"],
            correct: 0
        },
        {
            question: "ریڈ سندھی نسل کی گائے کہاں سے آتی ہے؟",
            options: ["پنجاب", "سندھ", "بلوچستان", "خیبر پختونخوا"],
            correct: 1
        },
        {
            question: "مراہ نسل کی بھینس کا رنگ کیا ہوتا ہے؟",
            options: ["بھورا", "سیاہ", "سفید", "چتکبرا"],
            correct: 1
        },
        {
            question: "ساہیوال نسل کی گائے کی خاصیت کیا ہے؟",
            options: ["زیادہ دودھ", "مزاحمت بیماری", "دونوں", "کوئی نہیں"],
            correct: 2
        },
        // Animal Health Questions
        {
            question: "گائے میں فٹ اینڈ ماؤتھ بیماری کی علامت کیا ہے؟",
            options: ["منہ میں چھالے", "پاؤں میں سوجن", "دونوں", "کوئی نہیں"],
            correct: 2
        },
        {
            question: "نیوکاسل بیماری کس جانور میں ہوتی ہے؟",
            options: ["گائے", "مرغی", "بکری", "بھیڑ"],
            correct: 1
        },
        {
            question: "گائے کو کالی کھانسی کی ویکسین کب لگائی جاتی ہے؟",
            options: ["6 ماہ", "12 ماہ", "18 ماہ", "24 ماہ"],
            correct: 0
        },
        {
            question: "جانور کو بخار ہونے پر کیا کرنا چاہیے؟",
            options: ["ڈاکٹر کو بلائیں", "پانی دیں", "سایہ میں رکھیں", "سب کچھ"],
            correct: 3
        },
        {
            question: "جانوروں کی صفائی کتنی بار کرنی چاہیے؟",
            options: ["روزانہ", "ہفتے میں دو بار", "ہفتے میں ایک بار", "مہینے میں ایک بار"],
            correct: 0
        },
        // Feeding & Nutrition Questions
        {
            question: "چارے کی کون سی قسم سب سے بہتر ہے؟",
            options: ["سبز چارہ", "خشک چارہ", "دونوں", "کوئی نہیں"],
            correct: 2
        },
        {
            question: "سردیوں میں جانوروں کو کیا کھلانا چاہیے؟",
            options: ["زیادہ چارہ", "زیادہ دانہ", "متوازن خوراک", "کم خوراک"],
            correct: 2
        },
        {
            question: "گرمیوں میں جانوروں کو کتنا پانی چاہیے؟",
            options: ["عام سے زیادہ", "عام جتنا", "عام سے کم", "کوئی نہیں"],
            correct: 0
        },
        {
            question: "گائے کے لیے متوازن خوراک میں کیا شامل ہونا چاہیے؟",
            options: ["چارہ", "دانہ", "نمک", "سب کچھ"],
            correct: 3
        },
        // Dairy & Milk Production Questions
        {
            question: "دودھ نکالنے کا بہترین وقت کیا ہے؟",
            options: ["صبح", "شام", "دونوں وقت", "رات"],
            correct: 2
        },
        {
            question: "دودھ کی مقدار پر کیا اثر انداز ہوتا ہے؟",
            options: ["خوراک", "پانی", "صحت", "سب کچھ"],
            correct: 3
        },
        {
            question: "دودھ کو کتنے درجہ حرارت پر محفوظ رکھنا چاہیے؟",
            options: ["2-4 ڈگری", "4-6 ڈگری", "6-8 ڈگری", "8-10 ڈگری"],
            correct: 0
        },
        {
            question: "دودھ نکالنے سے پہلے کیا کرنا چاہیے؟",
            options: ["ہاتھ دھونا", "تھن صاف کرنا", "دونوں", "کوئی نہیں"],
            correct: 2
        },
        // Reproduction & Breeding Questions
        {
            question: "گائے میں حرارت کی علامت کیا ہے؟",
            options: ["بے چینی", "چھلانگیں", "دونوں", "کوئی نہیں"],
            correct: 2
        },
        {
            question: "مصنوعی حمل کا طریقہ کیا کہلاتا ہے؟",
            options: ["AI", "IVF", "ET", "سب"],
            correct: 0
        },
        {
            question: "گائے کا حمل کتنا عرصہ رہتا ہے؟",
            options: ["7 ماہ", "9 ماہ", "11 ماہ", "13 ماہ"],
            correct: 1
        },
        {
            question: "بچھڑے کی پیدائش کے بعد کیا کرنا چاہیے؟",
            options: ["صاف کرنا", "دودھ پلانا", "ڈاکٹر کو بلانا", "سب کچھ"],
            correct: 3
        },
        // Farm Management Questions
        {
            question: "ایک گائے کے لیے کتنی جگہ چاہیے؟",
            options: ["20-30 مربع فٹ", "40-50 مربع فٹ", "60-70 مربع فٹ", "80-90 مربع فٹ"],
            correct: 1
        },
        {
            question: "کون سا ریکارڈ رکھنا ضروری ہے؟",
            options: ["دودھ کا", "خوراک کا", "صحت کا", "سب کچھ"],
            correct: 3
        },
        {
            question: "فارم کا بجٹ بناتے وقت کیا شامل کرنا چاہیے؟",
            options: ["خوراک کا خرچ", "ڈاکٹر کا خرچ", "بجلی کا خرچ", "سب کچھ"],
            correct: 3
        },
        {
            question: "جانوروں کے لیے گھر میں کیا ضروری ہے؟",
            options: ["ہوا", "روشنی", "صفائی", "سب کچھ"],
            correct: 3
        },
        // Market Knowledge Questions
        {
            question: "مویشی منڈی میں قیمت کا تعین کیسے ہوتا ہے؟",
            options: ["وزن", "نسل", "صحت", "سب کچھ"],
            correct: 3
        },
        {
            question: "گائے کا وزن اندازہ کیسے لگایا جاتا ہے؟",
            options: ["ناپ کر", "دیکھ کر", "ٹیپ سے", "سب"],
            correct: 2
        },
        {
            question: "منڈی میں بہترین قیمت کب ملتی ہے؟",
            options: ["عید سے پہلے", "عام دن", "موسم میں", "ہمیشہ"],
            correct: 0
        },
        {
            question: "مویشی کی قیمت پر کیا اثر انداز ہوتا ہے؟",
            options: ["وزن", "عمر", "صحت", "سب کچھ"],
            correct: 3
        },
        // Local Cultural Practices Questions
        {
            question: "عید الاضحیٰ کے لیے جانور کا انتخاب کیسے کریں؟",
            options: ["صحت مند", "درست عمر", "اچھی نسل", "سب کچھ"],
            correct: 3
        },
        {
            question: "مویشی میلے میں کیا دیکھنا چاہیے؟",
            options: ["نسل", "صحت", "قیمت", "سب کچھ"],
            correct: 3
        },
        {
            question: "عید کے لیے بکرا کتنی عمر کا ہونا چاہیے؟",
            options: ["6 ماہ", "12 ماہ", "18 ماہ", "24 ماہ"],
            correct: 1
        },
        {
            question: "میلے میں جانور خریدنے سے پہلے کیا چیک کریں؟",
            options: ["صحت", "نسل", "قیمت", "سب کچھ"],
            correct: 3
        }
    ];

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [showResult, setShowResult] = useState(false);
    const [showStartScreen, setShowStartScreen] = useState(true);
    const [gameStarted, setGameStarted] = useState(false);
    const [gameEnded, setGameEnded] = useState(false);
    const [usedQuestions, setUsedQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [timeLeft, setTimeLeft] = useState(30);
    const [answered, setAnswered] = useState(false);
    const clockTickAudioRef = useRef(null);
    const correctAudioRef = useRef(null);
    const failAudioRef = useRef(null);

    // Shuffle and select random questions
    const getRandomQuestion = () => {
        const availableQuestions = questions.filter((_, index) => !usedQuestions.includes(index));
        if (availableQuestions.length === 0) {
            // Reset if all questions used
            setUsedQuestions([]);
            return questions[Math.floor(Math.random() * questions.length)];
        }
        const randomIndex = Math.floor(Math.random() * availableQuestions.length);
        const question = availableQuestions[randomIndex];
        const originalIndex = questions.findIndex(q => q.question === question.question);
        setUsedQuestions(prev => [...prev, originalIndex]);
        return question;
    };

    // Initialize audio files
    useEffect(() => {
        clockTickAudioRef.current = new Audio('/sounds/clock-tick.mp3');
        clockTickAudioRef.current.volume = 0.3; // Set volume to 30% for background sound
        clockTickAudioRef.current.loop = true; // Loop the clock-tick sound
        
        correctAudioRef.current = new Audio('/sounds/correct.mp3');
        correctAudioRef.current.volume = 0.7; // Set volume to 70%
        
        failAudioRef.current = new Audio('/sounds/fail.mp3');
        failAudioRef.current.volume = 0.7; // Set volume to 70%
        
        return () => {
            if (clockTickAudioRef.current) {
                clockTickAudioRef.current.pause();
                clockTickAudioRef.current = null;
            }
            if (correctAudioRef.current) {
                correctAudioRef.current.pause();
                correctAudioRef.current = null;
            }
            if (failAudioRef.current) {
                failAudioRef.current.pause();
                failAudioRef.current = null;
            }
        };
    }, []);

    const startGame = () => {
        setShowStartScreen(false);
        setGameStarted(true);
        setGameEnded(false);
        setScore(0);
        setCurrentQuestionIndex(0);
        setUsedQuestions([]);
        setSelectedAnswer(null);
        setShowResult(false);
        setTimeLeft(30);
        setAnswered(false);
        setCurrentQuestion(getRandomQuestion());
        
        // Start background clock-tick sound
        if (clockTickAudioRef.current) {
            try {
                clockTickAudioRef.current.currentTime = 0; // Reset to start
                clockTickAudioRef.current.play().catch(error => {
                    // Handle autoplay restrictions
                    console.log('Could not play clock-tick sound:', error);
                });
            } catch (error) {
                console.log('Error playing clock-tick sound:', error);
            }
        }
    };

    useEffect(() => {
        if (!gameStarted || gameEnded || !currentQuestion) return;

        const timer = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    handleTimeUp();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [gameStarted, gameEnded, currentQuestion]);

    const handleTimeUp = () => {
        setAnswered(true);
        setShowResult(true);
        
        // Play fail sound when time runs out
        if (failAudioRef.current) {
            try {
                failAudioRef.current.currentTime = 0; // Reset to start
                failAudioRef.current.play().catch(error => {
                    // Handle autoplay restrictions
                    console.log('Could not play fail sound:', error);
                });
            } catch (error) {
                console.log('Error playing fail sound:', error);
            }
        }
        
        setTimeout(() => {
            nextQuestion();
        }, 2000);
    };

    const handleAnswer = (answerIndex) => {
        if (answered) return;
        
        setSelectedAnswer(answerIndex);
        setAnswered(true);
        
        const isCorrect = answerIndex === currentQuestion.correct;
        if (isCorrect) {
            setScore(prev => prev + 10);
            
            // Play correct sound
            if (correctAudioRef.current) {
                try {
                    correctAudioRef.current.currentTime = 0; // Reset to start
                    correctAudioRef.current.play().catch(error => {
                        // Handle autoplay restrictions
                        console.log('Could not play correct sound:', error);
                    });
                } catch (error) {
                    console.log('Error playing correct sound:', error);
                }
            }
        } else {
            // Play fail sound
            if (failAudioRef.current) {
                try {
                    failAudioRef.current.currentTime = 0; // Reset to start
                    failAudioRef.current.play().catch(error => {
                        // Handle autoplay restrictions
                        console.log('Could not play fail sound:', error);
                    });
                } catch (error) {
                    console.log('Error playing fail sound:', error);
                }
            }
        }
        
        setShowResult(true);
        
        setTimeout(() => {
            nextQuestion();
        }, 2000);
    };

    const nextQuestion = () => {
        if (currentQuestionIndex >= 24) {
            // Game over after 25 questions
            setGameEnded(true);
            setGameStarted(false);
            
            // Stop background clock-tick sound
            if (clockTickAudioRef.current) {
                clockTickAudioRef.current.pause();
                clockTickAudioRef.current.currentTime = 0;
            }
            
            if (onGameComplete) {
                setTimeout(() => onGameComplete(score), 500);
            }
        } else {
            setCurrentQuestionIndex(prev => prev + 1);
            setSelectedAnswer(null);
            setShowResult(false);
            setTimeLeft(30);
            setAnswered(false);
            setCurrentQuestion(getRandomQuestion());
        }
    };

    const getScoreMessage = () => {
        if (score >= 225) return "🏆 بہترین! آپ مویشی پالنے کے ماہر ہیں!";
        if (score >= 175) return "⭐ شاندار! بہت اچھا علم ہے!";
        if (score >= 125) return "👍 اچھا! سیکھتے رہیں!";
        if (score >= 75) return "📚 برا نہیں! مویشی پالنے کے بارے میں مزید پڑھیں!";
        return "💪 مشق جاری رکھیں!";
    };

    // Cover page with image
    if (showStartScreen && !gameStarted && !gameEnded) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '0',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(24, 144, 255, 0.2)',
                overflow: 'hidden'
            }}>
                {/* Game Preview Image */}
                <div style={{
                    width: '100%',
                    height: '400px',
                    background: 'linear-gradient(180deg, #87CEEB 0%, #E0F6FF 30%, #98D8C8 70%, #90EE90 100%)',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img 
                        src="/assets/images/maveshi-quiz.jpg" 
                        alt="Livestock Quiz Game"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            objectPosition: 'center'
                        }}
                        onError={(e) => {
                            // Fallback if image doesn't exist
                            e.target.style.display = 'none';
                        }}
                    />
                </div>
                
                {/* Start Button Section */}
                <div style={{
                    padding: '20px 16px',
                    background: 'rgba(255, 255, 255, 0.95)'
                }}>
                    <Title level={5} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '16px' }}>
                        🐄 مویشی پالنے کا علم کا کویز
                    </Title>
                    <Text style={{ 
                        fontSize: '13px', 
                        color: '#666',
                        display: 'block',
                        marginBottom: '12px'
                    }}>
                        مویشی پالنے کے بارے میں اپنے علم کا امتحان لیں! 25 سوالات کے جوابات دیں۔
                    </Text>
                    <Button
                        type="primary"
                        size="middle"
                        icon={<TrophyOutlined />}
                        onClick={startGame}
                        style={{
                            height: '36px',
                            fontSize: '13px',
                            fontWeight: 600,
                            borderRadius: '8px',
                            padding: '0 20px',
                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                        }}
                    >
                        کویز شروع کریں
                    </Button>
                </div>
            </div>
        );
    }

    if (!gameStarted && !gameEnded) {
        return null;
    }

    if (gameEnded) {
        return (
            <div style={{
                textAlign: 'center',
                padding: '30px 20px',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                border: '1px solid rgba(24, 144, 255, 0.2)'
            }}>
                <TrophyOutlined style={{ fontSize: '50px', color: '#ffd700', marginBottom: '15px' }} />
                <Title level={4} style={{ marginBottom: '10px', color: '#1890ff', fontSize: '20px' }}>
                    کویز مکمل!
                </Title>
                <Text style={{ fontSize: '32px', fontWeight: 'bold', color: '#52c41a', display: 'block', marginBottom: '10px' }}>
                    اسکور: {score}/250
                </Text>
                <Text style={{ fontSize: '16px', color: '#666', display: 'block', marginBottom: '20px' }}>
                    {getScoreMessage()}
                </Text>
                <Button
                    type="primary"
                    size="large"
                    icon={<ReloadOutlined />}
                    onClick={() => {
                        setShowStartScreen(true);
                        setGameEnded(false);
                    }}
                    style={{
                        height: '44px',
                        fontSize: '15px',
                        fontWeight: 600,
                        borderRadius: '10px',
                        padding: '0 24px',
                        background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                        border: 'none',
                        boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                    }}
                >
                    دوبارہ کھیلیں
                </Button>
            </div>
        );
    }

    return (
        <div style={{ width: '100%' }}>
            {/* Progress Bar */}
            <div style={{
                marginBottom: '16px',
                padding: '12px 16px',
                background: 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                border: '1px solid rgba(24, 144, 255, 0.2)'
            }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                    <Text style={{ fontSize: '14px', fontWeight: 600, color: '#1890ff' }}>
                        سوال {currentQuestionIndex + 1} از 25
                    </Text>
                    <Text style={{ fontSize: '14px', fontWeight: 600, color: timeLeft <= 10 ? '#ff4d4f' : '#52c41a' }}>
                        ⏱️ {timeLeft} سیکنڈ
                    </Text>
                    <Text style={{ fontSize: '14px', fontWeight: 600, color: '#1890ff' }}>
                        اسکور: {score}
                    </Text>
                </div>
                <Progress 
                    percent={((currentQuestionIndex + 1) / 25) * 100} 
                    showInfo={false}
                    strokeColor={{
                        '0%': '#108ee9',
                        '100%': '#87d068',
                    }}
                />
            </div>

            {/* Question Card */}
            {currentQuestion && (
                <div style={{
                    padding: '24px',
                    background: 'rgba(255, 255, 255, 0.95)',
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                    border: '1px solid rgba(24, 144, 255, 0.2)',
                    marginBottom: '16px'
                }}>
                    <Title level={4} style={{ marginBottom: '20px', color: '#1890ff', fontSize: '18px', textAlign: 'center', direction: 'rtl' }}>
                        {currentQuestion.question}
                    </Title>
                    
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {currentQuestion.options.map((option, index) => {
                            const isCorrect = index === currentQuestion.correct;
                            const isSelected = selectedAnswer === index;
                            const showCorrect = showResult && isCorrect;
                            const showIncorrect = showResult && isSelected && !isCorrect;
                            
                            return (
                                <Button
                                    key={index}
                                    size="large"
                                    onClick={() => handleAnswer(index)}
                                    disabled={answered}
                                    style={{
                                        height: '50px',
                                        fontSize: '15px',
                                        textAlign: 'right',
                                        direction: 'rtl',
                                        borderRadius: '10px',
                                        border: showCorrect 
                                            ? '2px solid #52c41a' 
                                            : showIncorrect 
                                            ? '2px solid #ff4d4f' 
                                            : '1px solid #d9d9d9',
                                        background: showCorrect
                                            ? 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)'
                                            : showIncorrect
                                            ? 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)'
                                            : 'white',
                                        color: showCorrect || showIncorrect ? '#000' : '#000',
                                        fontWeight: 500
                                    }}
                                    icon={showCorrect ? <CheckCircleOutlined style={{ color: '#52c41a' }} /> : showIncorrect ? <CloseCircleOutlined style={{ color: '#ff4d4f' }} /> : null}
                                >
                                    {option}
                                </Button>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default LivestockQuiz;

